/**
 * Shared formatting utilities
 */

export const formatCurrency = (amount: number, currency = 'USD'): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(amount)
}

export const formatDate = (date: Date): string => {
  return new Intl.DateTimeFormat('en-US').format(date)
}

/**
 * Formats a price value with currency symbol
 * @param value - The numeric value to format
 * @param currency - Currency symbol (default: 'US$')
 * @returns Formatted price string
 */
export const priceWithCurrency = (value = '', currency = 'US$'): string => {
  const num = parseFloat(value)
  const safe = Number.isFinite(num) ? num : 0
  const formatted = safe.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  return `${currency} ${formatted}`
}
